import escapeRegExp from "lodash.escaperegexp";

import { getConfig } from "../../config/app";

export const addFindAndGetUrls = (router: any) => {
  const basePath = getConfig("basePath");

  const oldFindAndGetUrls = router.findAndGetUrls.bind(router);
  router.findAndGetUrls = (nameOrUrl: any, params: any) => {
    let mNameOrUrl = nameOrUrl;
    if (basePath && basePath !== "/") {
      const re = new RegExp(`^${escapeRegExp(basePath)}`);
      mNameOrUrl = nameOrUrl.replace(re, "");
    }

    const findAndGetUrls = oldFindAndGetUrls(mNameOrUrl, params);

    if (basePath && basePath !== "/") {
      findAndGetUrls.urls.as = `${basePath}${findAndGetUrls.urls.as}`;
    }

    return findAndGetUrls;
  };

  // PATCH match method
  const originalMatch = router.match.bind(router);
  router.match = (url: string) => {
    let nextUrl = url;
    if (url && basePath && basePath !== "/") {
      nextUrl = url.indexOf(basePath) === 0 ? url.replace(basePath, "") : url;
    }

    return originalMatch(nextUrl);
  };

  return router;
};
